import { Button, Callout } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { WorkspaceScheduleJob } from "@/types/workspaces";
import { formatDate } from "@/utils/datetime";

interface BulkInviteSchedulingBannerProps {
  onOpenBulkInviteDetail: (scheduleJob: WorkspaceScheduleJob) => void;
  scheduleJob: WorkspaceScheduleJob;
}

export function BulkInviteSchedulingBanner({
  onOpenBulkInviteDetail,
  scheduleJob,
}: BulkInviteSchedulingBannerProps) {
  const { scheduledAt } = scheduleJob;
  return (
    <Callout
      intent={"primary"}
      title={"Invitations Scheduled"}
      icon={"calendar"}
    >
      <Box color="black" mt={2}>
        New users are scheduled to receive invitations on{" "}
        {formatDate(scheduledAt, "EEE. MMM d, yyyy 'at' hh:mm a z")}
      </Box>
      <Box mt={2}>
        <Button
          large={true}
          onClick={() => onOpenBulkInviteDetail(scheduleJob)}
        >
          Edit Invitations
        </Button>
      </Box>
    </Callout>
  );
}
